import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WizardN35EncuestadorService } from 'app/main/wizard-n35encuestador/services/wizardn35encuestador.services';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import { lang_certificar } from 'app/idiomas/i18n/encuestador35/encuestador35.lang';
import { lang_cierre } from 'app/idiomas/i18n/cierre/cierre.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Cierren35Service } from 'app/main/wizard-n35encuestador/services/cierren35.service';
import { Envion35Service } from 'app/main/wizard-n35encuestador/services/envion35.service';
import Swal from 'sweetalert2';
import * as backInter from 'app/auth/auth-data.model';
import * as backClose from './close35.interface';

@Component({
  selector: 'app-close35',
  templateUrl: './close35.component.html',
  styleUrls: ['./close35.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations : fuseAnimations
})
export class Close35Component implements OnInit {
  pasoCompleto = false;
  centered = false;
  disabled = false;
  unbounded = false;
  flagCierre= true;
  productoCertificar35: backInter.prodNorma35;
  fechaCertificar35: any;
  radius: number;
  color: string;

  porcentaje:any;
  porcentaje2:any;
  tmp:any;
  tmp2:any;
  avanceEncuesta:backClose.objetoMenos50;
  typeSurvey1:boolean=false; // +mas
  typeSurvey2:boolean=false; // -50
  cargando:boolean=true;
  Finalizada1:boolean=false;
  Finalizada2:boolean

  constructor(
    private service : Cierren35Service,
    private envioService: Envion35Service,
    private translateSrv: TranslateService,
    private wizardService: WizardN35EncuestadorService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService)
    {
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_cierre.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }


  ngOnInit() {
    this.obtieneCertificarActual();
    // localStorage.setItem('tipoProducto', "5");
  }
  banderaFecha:any;
  obtieneCertificarActual(){
    //console.log("netro");
    this.service.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      console.log("Certificar actual");
      console.log(data.productosNorma35);
      this.banderaFecha=data.productosNorma35[0].fechaNorma35;
      this.getRecordatoriosFechas();
      //console.log("Producto");
      //console.log(prodsCertificar);
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            this.fechaCertificar35=producto.fechaNorma35;

            if(producto.completoNorma35 === 1){
              this.productoCertificar35 = producto;
              this.cierre(this.productoCertificar35.idNorma35);
              //localStorage.getItem('fechaProducto');
              localStorage.setItem('fechaProducto',''+this.productoCertificar35.fechaNorma35);
              // localStorage.setItem('tipoProducto', "5");
              localStorage.setItem('productoID', this.productoCertificar35.idNorma35);
              throw BreakException;
            }
          }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.service.getStatu(this.productoCertificar35.idNorma35,true).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3){
          this.pasoCompleto = true;
        }
      });
      //obtiene las preguntas adicionales guardadas
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }
  avaneLabel:string;
  cierre(productoId){
    let dataEnc={
      productoId: this.productoCertificar35.idNorma35
    };

    this.envioService.obtenerPilito(dataEnc)
    .subscribe((response:backInter.getPilotoN35) => {
      if(response.success){
        if(response.urlMas50.length > 1 && response.urlMenos50.length>1){
          this.typeSurvey1=true;
          this.typeSurvey2=true;
          this.cargando=false;
          this.flagCierre=false;
          this.service.closesurvey(productoId,0).subscribe((data:backInter.surveyprogress) => {

            this.tmp=data.avance;
            this.porcentaje=this.tmp.porcentaje;
            this.service.closesurvey(productoId,1).subscribe((data2:backInter.surveyprogress) => {

              this.tmp2=data2.avance;
              this.porcentaje2=this.tmp2.porcentaje;
              console.log("porcentaje");
              console.log(this.porcentaje2);
              if(this.porcentaje2=='100'){

              }
              this.avaneLabel="Avance +50: ";
              if(this.porcentaje== '100' && this.porcentaje2=='100'){

              }
            });
          });

        }else{
          if(response.urlMas50.length > 1){
            console.log("urlMas50");
            this.service.closesurvey(productoId,0).subscribe((data:backInter.surveyprogress) => {
              this.flagCierre=false;
              this.tmp=data.avance;
              this.porcentaje=this.tmp.porcentaje;
              this.cargando=false;
              this.typeSurvey2=true;
              this.avaneLabel="Avance +50: ";
              if(this.porcentaje== 100 && this.porcentaje2==100){
                this.Finalizada2=true;
              }
            });
          }
          if(response.urlMenos50.length>1){
            console.log("urlmeos50");
            this.service.closesurvey(productoId,1).subscribe((data:backInter.surveyprogress) => {
              this.flagCierre=false;
              this.tmp=data.avance;
              this.porcentaje=this.tmp.porcentaje;
              this.cargando=false;
              this.typeSurvey1=true;
              this.avaneLabel="Avance -50: ";
              console.log("Porcentaje");
              console.log(this.porcentaje);
              if(this.porcentaje== 100){
                this.Finalizada1=true;
              }
          });
          }

        }
      }
    }, error => {
      console.log(error);
    });

    //console.log("Parte de cierre");

    // data:backClose.cierre

    //closesurvey
  }

  typeSurvey(type){
    console.log("Type  survey"+type);
    // 1 es menos de 50 y 2 más de 50
    if(type==1){
      localStorage.setItem('surveytype',"1");
    }else{
      localStorage.setItem('surveytype',"0");

    }

  }

  completarPaso(){
    this.aletaRestric('ENVIO.COMPLETAR',true);
  }

  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }
  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          this.service.saveStatus(this.productoCertificar35.idNorma35).subscribe( (data: backInter.RespuestaGen) => {
            console.log("Completar paso");
            console.log(data);
            if(data.message == '216'){
              this.aletaRestric('ENVIO.'+data.message,null,'success');
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      let tipoMsg: any = tipo;
      Swal.fire({
        title: texto,
        icon: tipoMsg,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }

  }
  auxCorreo_array:any;
  Cargandocorreo:boolean=false;
  sendReminder(tipoEncuesta:any){

    if(this.labelDate){
      this.Cargandocorreo=true;
      var now = new Date();
      var date2 = new Date(now),
      mnth = ("0" + (date2.getMonth() + 1)).slice(-2),
        day = ("0" + date2.getDate()).slice(-2);
      var timestamp1 = new Date(this.labelDate).getTime();
      var timestamp2 = new Date(date2).getTime();
      if(timestamp2>timestamp1){
        let dataRecor={
          productoId: this.productoCertificar35.idNorma35,
        };
        this.envioService.GetRecordatoriosManuales(dataRecor)
          .subscribe((response:any) => {
            this.auxCorreo_array=response.recordatoriosManuales;
              var pos= this.auxCorreo_array.length;
              if(pos == 0){
                this.enviarCorreos(tipoEncuesta);
              }else if(pos > 0) {
                var timestampRecordatorio1 = new Date(this.auxCorreo_array[pos-1].fechaRecordatorio).getTime();
                var timestampRecordatorio2 = new Date(date2).getTime();
                var tiempoRecordatorios = timestampRecordatorio2-timestampRecordatorio1;
                if(tiempoRecordatorios >= 86400000){
                  this.enviarCorreos(tipoEncuesta);
                }else{
                  this.Cargandocorreo=false;
                  let texto = 'CIERRE.LABEL6';
                  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                  Swal.fire({
                    title: texto,
                    icon: "error",
                    confirmButtonColor: '#e40601'
                  });
                }
              }

        }, error => {
              console.log(error);
        });
      }else{
        let texto = 'CIERRE.LABEL7';
        this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
        Swal.fire({
          title: texto,
          icon: "error",
          confirmButtonColor: '#e40601'
        });
        setTimeout(() => {
          this.Cargandocorreo=false;
        }, 1000);
      }
    }
  }
  labelDate:any;
  arrayRemainders:any;
  arrayRemaindersExt:any;
  getRecordatoriosFechas(){
    let data={
      'fechaNorma35' : this.banderaFecha
    };
    this.service.getReminders(data)
    .subscribe(response => {
      if(response['message'] == '200'){
        if(this.arrayRemainders = response['recordatoriosMostrar'].length>0){
          this.arrayRemainders = response['recordatoriosMostrar'];
          if(this.arrayRemainders.length == 3){
            this.labelDate=this.arrayRemainders[0].fechaRecordatorio;
          }else if(this.arrayRemainders.length >= 5){
            this.labelDate=this.arrayRemainders[2].fechaRecordatorio;
          }
        }
      }
    }, error => {
      console.log(error);
    });
  }


  rutaEncuestador:any;
  addColaboradores(val: string){
    let texto = 'CIERRE.CIERRE.COPYLINK';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    // let url = DATOS_API.url.split(":");
    // this.rutaPagina = url[1] + "/surveyadministrator/counting/" + val;
    //DATOS_API.urlConteos + val;
    var empresa="1233";
    var pod="1234";
    var centro="1233";
    var idct="123";
    this.rutaEncuestador = 'home?empresa='+empresa+'&pod='+pod+'&centro='+centro+'&idct='+idct;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    // selBox.value=val;
    selBox.value=this.rutaEncuestador;
    console.log(this.rutaEncuestador);
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    Swal.fire({
      icon: 'success',
      title: texto,

    });
  }

  enviarCorreos(tipoEncuesta){

    let dataEnc={
      productoId: this.productoCertificar35.idNorma35,
      tipoEncuesta: tipoEncuesta
    };
    this.envioService.RecordatoriosManuales(dataEnc)
    .subscribe((response:any) => {
      this.Cargandocorreo=false;
      console.log("Respuesta recordatorios");
      console.log(response);
      let texto = 'CIERRE.LABEL5';
      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
      Swal.fire({
        title: texto,
        icon: "success",
        confirmButtonColor: '#e40601'
      });
      console.log(response);

    }, error => {
      console.log(error);
    });
  }




}
